import { ICON } from "../components/Icon/data";
import i18n from "../i18n";

export const MIN_FULLWIDTH = 1035;

export enum COLOR {
  SUCCESS_GREEN = '#24A148',
  WARNING_YELLOW = '#F1C21B',
  ERROR_RED = '#DA1E28',
  INFO_BLUE = '#0043CE',
  WHITE = '#FFFFFF',
  BLACK = '#000000',
  FLOTI_RED = '#70140E',
  TEXT_GRAY = '#161616',
  GRAY_60 = '#6F6F6F',
  GRAY_30 = '#C6C6C6',
  RED_80 = '#98281F',
  RED_70 = '#D42020',
  BLUE_70 = '#016CCE',
  YELLOW_80 = '#B26200',
  GREEN_50 = '#28A048',
  GREEN_70 = '#0C6027',
  YELLOW_70 = '#F49C18',
  ORANGE_40 = '#FFA706',
  MARKER_BLUE = '#03A0D7',
  MARKER_RED = '#d70338',
  MARKER_GREEN = '#03d75b',
  TAG_GREEN = '#0E6027',
  TAG_MAGENTA = '#9F1853',
  TAG_CYAN = '#00539A',
}

export enum KEY {
  ENTER = 'Enter',
  TAB = 'Tab',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
  MOUSE_LEFT = 1,
  MOUSE_RIGHT = 2,
  MOUSE_MIDDLE = 4
}

export const MOBILE_ICONS = {
  arrow_blue: {
    icon: ICON.CURRENT_LOCATION,
    icon_text: i18n.t('Arrow'),
    color: COLOR.BLUE_70,
    color_text: i18n.t('Blue')
  },
  arrow_red: {
    icon: ICON.CURRENT_LOCATION,
    icon_text: i18n.t('Arrow'),
    color: COLOR.RED_70,
    color_text: i18n.t('Red')
  },
  arrow_green: {
    icon: ICON.CURRENT_LOCATION,
    icon_text: i18n.t('Arrow'),
    color: COLOR.GREEN_50,
    color_text: i18n.t('Green')
  },
  arrow_yellow: {
    icon: ICON.CURRENT_LOCATION,
    icon_text: i18n.t('Arrow'),
    color: COLOR.YELLOW_70,
    color_text: i18n.t('Yellow')
  },
  circle_blue: {
    icon: ICON.CIRCLE_SOLID,
    icon_text: i18n.t('Circle'),
    color: COLOR.BLUE_70,
    color_text: i18n.t('Blue')
  },
  circle_red: {
    icon: ICON.CIRCLE_SOLID,
    icon_text: i18n.t('Circle'),
    color: COLOR.RED_70,
    color_text: i18n.t('Red')
  },
  circle_green: {
    icon: ICON.CIRCLE_SOLID,
    icon_text: i18n.t('Circle'),
    color: COLOR.GREEN_50,
    color_text: i18n.t('Green')
  },
  circle_yellow: {
    icon: ICON.CIRCLE_SOLID,
    icon_text: i18n.t('Circle'),
    color: COLOR.YELLOW_70,
    color_text: i18n.t('Yellow')
  }
}

export enum FORMAT_TYPE {
  STRING = 'string',
  DATETIME = 'datetime',
  DATE = 'date',
  DISTANCE = 'distance',
  DURATION = 'duration',
  SPEED = 'speed',
  BOOLEAN = 'boolean',
  FILE = 'file',
  METERS = 'meters',
  NUMBER = 'number',
  TIME = 'time',
  MINUTES = 'minutes',
  NONE = 'none',
  KILOMETERS = 'kilometers',
  HOURS = 'hours',
  ONE_DECIMAL = 'one_decimal',
  LETTER_GRADE = 'letter_grade',
}

export const WEEKDAYS: Record<number, string> = {
  1: i18n.t('Monday'),
  2: i18n.t('Tuesday'),
  3: i18n.t('Wednesday'),
  4: i18n.t('Thursday'),
  5: i18n.t('Friday'),
  6: i18n.t('Saturday'),
  7: i18n.t('Sunday')
}

export const MONTHS: Record<number, string>  = {
  1: i18n.t('January'),
  2: i18n.t('February'),
  3: i18n.t('March'),
  4: i18n.t('April'),
  5: i18n.t('May'),
  6: i18n.t('June'),
  7: i18n.t('July'),
  8: i18n.t('August'),
  9: i18n.t('September'),
  10: i18n.t('October'),
  11: i18n.t('November'),
  12: i18n.t('December')
}

export const COOKIE: Record<string, string> = {
  LIVEMAP_FLEET_SELECTION: 'liveMap_fleet_sel'
}

export const SINGLE_TIME_UNIT: Record<string, string> = {
  minutes: 'm',
  hours: 'h',
  days: 'd',
  months: 'M',
}
